import { adminAlertsApi } from "../ENV";
import { fetchApi } from "./FetchAPI";


export const fetchAlerts = async (page = 1, limit = 10, search = "") => {
    try {
      const headerValue = {
        Accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem('access_token')}`
      };
  
      const params = { page, limit };
      if (search && search.trim() !== '') {
        params.search = search;
      }
  
      const response = await fetchApi(
        adminAlertsApi,
        "GET",
        {},
        headerValue,
        params
      );
  
      if (response.status !== 200) {
        throw new Error('Failed to fetch alerts');
      }
  
      return response.data;
    } catch (error) {
      throw error;
    }
  };